const bulletin = [
  {
    title: '使用 Microsoft 加速您的雲之旅',
    alias: 'bulletinalais-1',
    category: '新訊',
    description: '雲是更輕鬆的遠程工作、增強網絡安全、機器學習等新技術的關鍵。這對於現代商業的成功至關重要。隨著物聯網市場的成熟，計算能力越來越多地被定位在邊緣，使處理和分析能力更接近連接的數據',
    publish_up: '2021/10/20',
    introimage: null
  },
  {
    title: '使用 Microsoft 加速您的雲之旅',
    alias: 'bulletinalais-2',
    category: '新訊',
    description: '隨著物聯網市場的成熟，計算能力越來越多地被定位在邊緣，使處理和分析能力更接近連接的數據',
    publish_up: '2021/10/18',
    introimage: null
  },
  {
    title: '使用 Microsoft 加速您的雲之旅',
    alias: 'bulletinalais-3',
    category: '新訊',
    description: '雲是更輕鬆的遠程工作、增強網絡安全、機器學習等新技術的關鍵。這對於現代商業的成功至關重要。隨著物聯網市場的成熟，計算能力越來越多地被定位在邊緣，使處理和分析能力更接近連接的數據',
    publish_up: '2021/10/02',
    introimage: null
  },
  {
    title: '使用 Microsoft 加速您的雲之旅',
    alias: 'bulletinalais-4',
    category: '新訊',
    description: '雲是更輕鬆的遠程工作、增強網絡安全、機器學習等新技術的關鍵。這對於現代商業的成功至關重要。',
    publish_up: '2021/10/01',
    introimage: null
  },
  {
    title: '使用 Microsoft 加速您的雲之旅',
    alias: 'bulletinalais-5',
    category: '新訊',
    description: '隨著物聯網市場的成熟，計算能力越來越多地被定位在邊緣雲是更輕鬆的遠程工作、增強網絡安全、機器學習等新技術的關鍵。這對於現代商業的成功至關重要。',
    publish_up: '2021/09/20',
    introimage: null
  },
  {
    title: '使用 Microsoft 加速您的雲之旅',
    alias: 'bulletinalais-6',
    category: '新訊',
    description: '隨著物聯網市場的成熟，計算能力越來越多地被定位在邊緣，使處理和分析能力更接近連接的數據',
    publish_up: '2021/09/20',
    introimage: null
  },
  // {
  //   title: '微軟測次文字測試文字測試文字',
  //   category: 'AI+ML',
  //   alias: 'alais-7',
  //   class: ['整合開發'],
  //   description: '幫助城市和組織變得更安全、更智能測試文字測試文字',
  //   author: 'Hitachi',
  //   publish_up: '2021/10/16',
  //   introimage: null
  // },
  // {
  //   title: '微軟資源網路應用服務',
  //   category: 'AI+ML',
  //   alias: 'alais-8',
  //   class: ['影像辨識', '語音辨識', '自然語意', '整合開發', '深度學習'],
  //   description: null,
  //   author: 'Hitachi',
  //   publish_up: '2021/09/20',
  //   introimage: null
  // },
]


const event = [
  {
    title: '使用 Microsoft 加速您的雲之旅',
    alias: 'eventalais-1',
    seriesNum: 'abced',
    category: '活動',
    description: '雲是更輕鬆的遠程工作、增強網絡安全、機器學習等新技術的關鍵。這對於現代商業的成功至關重要。隨著物聯網市場的成熟，計算能力越來越多地被定位在邊緣，使處理和分析能力更接近連接的數據',
    publish_up: '2021/10/20',
    introimage: null
  },
  {
    title: '使用 Microsoft 加速您的雲之旅',
    alias: 'eventalais-2',
    seriesNum: 'abced',
    category: '活動',
    description: '隨著物聯網市場的成熟，計算能力越來越多地被定位在邊緣，使處理和分析能力更接近連接的數據',
    publish_up: '2021/10/20',
    introimage: null
  },
  {
    title: '使用 Microsoft 加速您的雲之旅',
    alias: 'eventalais-3',
    seriesNum: 'abced',
    category: '活動',
    description: '雲是更輕鬆的遠程工作、增強網絡安全、機器學習等新技術的關鍵。這對於現代商業的成功至關重要。隨著物聯網市場的成熟，計算能力越來越多地被定位在邊緣，使處理和分析能力更接近連接的數據',
    publish_up: '2021/10/15',
    introimage: null
  },
  {
    title: '使用 Microsoft 加速您的雲之旅',
    alias: 'eventalais-4',
    seriesNum: 'abced',
    category: '活動',
    description: '雲是更輕鬆的遠程工作、增強網絡安全、機器學習等新技術的關鍵。這對於現代商業的成功至關重要。',
    publish_up: '2021/10/13',
    introimage: null
  },
  {
    title: '使用 Microsoft 加速您的雲之旅',
    alias: 'eventalais-5',
    seriesNum: 'abced',
    category: '活動',
    description: '隨著物聯網市場的成熟，計算能力越來越多地被定位在邊緣雲是更輕鬆的遠程工作、增強網絡安全、機器學習等新技術的關鍵。這對於現代商業的成功至關重要。',
    publish_up: '2021/10/10',
    introimage: null
  },
  {
    title: '使用 Microsoft 加速您的雲之旅',
    alias: 'eventalais-6',
    seriesNum: 'abced',
    category: '活動',
    description: '隨著物聯網市場的成熟，計算能力越來越多地被定位在邊緣，使處理和分析能力更接近連接的數據',
    publish_up: '2021/09/12',
    introimage: null
  },
  // {
  //   title: 'IoT微軟測次文字測試文字測試文字',
  //   category: 'iot',
  //   alias: 'alais-7',
  //   class: ['整合開發'],
  //   description: '幫助城市和組織變得更安全、更智能幫助城市和組織變得更安全、更智能',
  //   author: 'iot solution',
  //   publish_up: '2021/08/20',
  //   introimage: ''
  // },
  // {
  //   title: 'IoT微軟資源網路應用服務',
  //   category: 'iot',
  //   alias: 'alais-8',
  //   class: ['影像辨識', '語音辨識', '自然語意', '整合開發', '深度學習'],
  //   description: '幫助城市和組織變得更安全、更智能幫助城市和組織變得更安全、更智能',
  //   author: 'iot solution',
  //   publish_up: '2021/08/15',
  //   introimage: null
  // },
]

export const FAKE_NEWS= {
  items: {
    'all': {
      items: [
        {
          title: '使用 Microsoft 加速您的雲之旅',
          alias: 'eventalais-1',
          seriesNum: 'abced',
          category: '活動',
          description: '雲是更輕鬆的遠程工作、增強網絡安全、機器學習等新技術的關鍵。這對於現代商業的成功至關重要。隨著物聯網市場的成熟，計算能力越來越多地被定位在邊緣，使處理和分析能力更接近連接的數據',
          publish_up: '2021/10/20',
          introimage: null
        },
        {
          title: '使用 Microsoft 加速您的雲之旅2',
          alias: 'bulletinalais-2',
          category: '新訊',
          description: '隨著物聯網市場的成熟，計算能力越來越多地被定位在邊緣，使處理和分析能力更接近連接的數據',
          publish_up: '2021/10/18',
          introimage: null
        },
        {
          title: '使用 Microsoft 加速您的雲之旅3',
          alias: 'bulletinalais-3',
          category: '新訊',
          description: '雲是更輕鬆的遠程工作、增強網絡安全、機器學習等新技術的關鍵。這對於現代商業的成功至關重要。隨著物聯網市場的成熟，計算能力越來越多地被定位在邊緣，使處理和分析能力更接近連接的數據',
          publish_up: '2021/10/02',
          introimage: null
        },
        {
          title: '使用 Microsoft 加速您的雲之旅4',
          alias: 'eventalais-2',
          seriesNum: 'abced',
          category: '活動',
          description: '隨著物聯網市場的成熟，計算能力越來越多地被定位在邊緣，使處理和分析能力更接近連接的數據',
          publish_up: '2021/10/20',
          introimage: null
        },
        {
          title: '使用 Microsoft 加速您的雲之旅5',
          alias: 'eventalais-3',
          seriesNum: 'abced',
          category: '活動',
          description: '雲是更輕鬆的遠程工作、增強網絡安全、機器學習等新技術的關鍵。這對於現代商業的成功至關重要。隨著物聯網市場的成熟，計算能力越來越多地被定位在邊緣，使處理和分析能力更接近連接的數據',
          publish_up: '2021/10/15',
          introimage: null
        },
        {
          title: '使用 Microsoft 加速您的雲之旅6',
          alias: 'bulletinalais-6',
          category: '新訊',
          description: '隨著物聯網市場的成熟，計算能力越來越多地被定位在邊緣，使處理和分析能力更接近連接的數據',
          publish_up: '2021/09/20',
          introimage: null
        },
      ],
      title: '全部消息'
    },
    'bulletin': {
      items: [...bulletin],
      title: '新訊',
    },
    'event': {
      items: [...event],
      title: '活動',
    },
  }
}

export const FAKE_BULLETINITEM = {
  alias: 'bulletin-1',
  title: '使用 Microsoft 加速您的雲之旅',
  categoryTitle: '新訊',
  introimage: require('@assets/images/news/newsItem@2.jpg'),
  publish_up: '2021-10-20',
  tags: [
    {
      alias: '教育',
      title: '教育'
    },
    {
      alias: '大型企業',
      title: '大型企業'
    },
    {
      alias: '傳播與通訊',
      title: '傳播與通訊'
    },
  ], // '媒體傳播', '醫療', '遊戲', '能源', '製造', '建築'
  description: `<h3>使用雙向通信構建您的 IoT 應用程序</h3><br><br><p>在您的物聯網 (IoT) 應用程序與其管理的設備之間實現高度安全和可靠的通信。Microsoft IoT 中心提供了一個雲託管解決方案後端，幾乎可以連接任何設備。通過每設備身份驗證、內置設備管理和擴展配置，將您的解決方案從雲擴展到邊緣。 在您的物聯網 (IoT) 應用程序與其管理的設備之間實現高度安全和可靠的通信。Microsoft IoT 中心提供了一個雲託管解決方案後端，幾乎可以連接任何設備。通過每設備身份驗證、內置設備管理和擴展配置，將您的解決方案從雲擴展到邊緣。在您的物聯網 (IoT) 應用程序與其管理的設備之間實現高度安全和可靠的通信。Microsoft IoT 中心提供了一個雲託管解決方案後端，幾乎可以連接任何設備。通過每設備身份驗證、內置設備管理和擴展配置，將您的解決方案從雲擴展到邊緣。 <br><br><img src="${require('@assets/images/news/newsItem@2.jpg')}"/><br><br>在您的物聯網 (IoT) 應用程序與其管理的設備之間實現高度安全和可靠的通信。Microsoft IoT 中心提供了一個雲託管解決方案後端，幾乎可以連接任何設備。通過每設備身份驗證、內置設備管理和擴展配置，將您的解決方案從雲擴展到邊緣。</p><p>在您的物聯網 (IoT) 應用程序與其管理的設備之間實現高度安全和可靠的通信。Microsoft IoT 中心提供了一個雲託管解決方案後端，幾乎可以連接任何設備。通過每設備身份驗證、內置設備管理和擴展配置，將您的解決方案從雲擴展到邊緣。 在您的物聯網 (IoT) 應用程序與其管理的設備之間實現高度安全和可靠的通信。Microsoft IoT 中心提供了一個雲託管解決方案後端，幾乎可以連接任何設備。通過每設備身份驗證、內置設備管理和擴展配置，將您的解決方案從雲擴展到邊緣。在您的物聯網 (IoT) 應用程序與其管理的設備之間實現高度安全和可靠的通信。Microsoft IoT 中心提供了一個雲託管解決方案後端，幾乎可以連接任何設備。通過每設備身份驗證、內置設備管理和擴展配置，將您的解決方案從雲擴展到邊緣。 在您的物聯網 (IoT) 應用程序與其管理的設備之間實現高度安全和可靠的通信。Microsoft IoT 中心提供了一個雲託管解決方案後端，幾乎可以連接任何設備。通過每設備身份驗證、內置設備管理和擴展配置，將您的解決方案從雲擴展到邊緣。</p>`,
  prev: {title: "人臉識別門禁考勤管理系統", alias: "bulletin-2"},
  next: {title: "V5 聲學槍聲傳感器 (V5 GSL)", alias: "bulletin-3"},
  solutions: [
    {
      title: '智能空間',
      alias: 'alais-1',
      category: 'AI+ML',
      class: [{
        alias: '自然語意',
        title: '自然語意'
      },
      {
        alias: '影像辨識',
        title: '影像辨識'
      },],
      description: '幫助城市和組織變得更安全、更智能',
      author: 'Hitachi',
      publish_up: '2021/10/20',
      introimage: null
    },
    {
      title: '微軟資源網路應用服務',
      category: 'AI+ML',
      alias: 'alais-2',
      class: [
        {
          alias: '自然語意',
          title: '自然語意'
        },
        {
          alias: '影像辨識',
          title: '影像辨識'
        },
        {
          alias: '數據分析',
          title: '數據分析'
        },
      ],
      description: '幫助城市和組織變得更安全、更智能測試文字測試文字',
      author: '微軟中心',
      publish_up: '2021/10/20',
      introimage: null
    },
    {
      title: '微軟測次文字測試文字測試文字',
      category: 'AI+ML',
      alias: 'alais-3',
      class: [
        {
          alias: '自然語意',
          title: '自然語意'
        },
      ],
      description: '幫助城市和組織變得更安全、更智能',
      author: 'Hitachi',
      publish_up: '2021/10/20',
      introimage: null
    },
  ]
}

export const FAKE_EVENTITEM = {

    "title": "一手掌握跨雲與多雲平台的資安與管理問題",
    "alias": "event_1",
    "seriesNum": "LRM5D",
    "state": 1,
    "type": "physical",
    "contact": [
      {
        "name": "商",
        "gender": "小姐",
        "countryCode": "02",
        "phone": "26565656",
        "extension": "786"
      },
    ],
    "categoryTitle": "活動",
    "dateType": "single",
    "dateTimeRange": "2022/01/31(ㄧ) (14:00-17:00)",
    "registrationType": "impartial",
    "registrationStartDate": "2022-01-04 00:00:00",
    "registrationEndDate": "2022-03-20 00:00:00",
    "hasAbsentLimit": 0,
    "absentLimit": 0,
    "canApply": 1,
    "chargeType": "impartial",
    "basePrice": 0,
    "salePrice": 0,
    "link": null,
    "bannerImage": null,
    "slideshow": [],
    "description": "<p>2017零壹科技Solution Day (台中場) 次世代AI雲平台與大數據資安防禦應用，你該知道的新趨勢 自從Google AlphaGo在圍棋上陸續戰勝世界棋王李世乭與柯潔後，AI人工智慧成為全世界關注的關鍵技術，更激發各種新興應用及新商業模式，進而讓人類未來生活與工作帶來各種想像，同時也為各行各業創造新的商機與挑戰。 近年來由於雲端科技發展日益成熟，促使了多元化的應用服務隨之崛起，藉此驅動了科技創新及數位轉型。<br><br>其中：AI人工智慧、雲端平台整合與大數據分析，是企業必須首要掌握的新趨勢。<br>除此之外，資安防護更是企業在追求新趨勢之際，不能被忽略的重要一環。 為了讓企業能掌握新趨勢，以因應未來的布局，此次2017零壹科技Solution Day台中場，我們將告訴您AI人工智慧如何正以驚人的速度發展；大數據分析藉由機器學習帶來更智能的預測；如何運用超融合軟硬整合，高效掌控數位資料；並帶領您因應未來資安的挑戰。 <br><br>歡迎您蒞臨零壹科技在8/25舉辦的2017零壹科技Solution Day台中場，「次世代AI雲平台與大數據資安防禦應用，你該知道的新趨勢」，與我們一同掌握先機！</p>",
    "introtext": `此為初階課程，配合實例解說案例，由淺入深講解 NetApp FAS / AFF 相關技術，利用實際操作的方式，印證理論和基礎的關聯性，協助參與此課程的 NetApp 使用者，能熟悉 NetApp FAS / AFF 產品的基本操作。此為初階課程，配合實例解說案例。 由淺入深講解 NetApp FAS / AFF 相關技術，利用實際操作的方式，印證理論和基礎的關聯性，協助參與此課程的 NetApp 使用者，能熟悉 NetApp FAS / AFF 產品的基本操作。 活動簡介測試文字活動簡介測試文字活動簡介測試文字活動簡介測試文字活動簡介測試文字`,
    "locationName": "零宇學苑601教室",
    "city": "台北市",
    "district": "中山區",
    "address": "中山北路二段9號",
    "zipcode": null,
    "lat": null,
    "lng": null,
    "canRegisterGroup": 6,
    "requireCoupon": 0,
    "phoneCode": null,
    "phone": null,
    "needReview": 1,
    "params": {
        "meta": {
            "title": "",
            "keywords": "",
            "description": ""
        },
        "seo": []
    },
    "inProgress": 0,
    "requiredEvent": [],
    "meals": [],
    "questions": [],
    "files": [],
    "sponsors": [
      {
        title: '中華電信',
        image: require('@assets/images/partner/中華電信.png'),
        link: 'https://www.cht.com.tw/home/consumer',
      },
      {
          title: 'Qualcomm',
          image: require('@assets/images/partner/Qualcomm.png'),
          link: null,
      },
      {
        title: '台灣大哥大',
        image: require('@assets/images/partner/台灣大哥大.png'),
        link: null,
      },
      {
        title: '智慧生活',
        image: require('@assets/images/partner/智慧生活.png'),
        link: null,
      },
      {
        title: 'BenQ',
        image: require('@assets/images/partner/BenQ.png'),
        link: null
      },
      {
        title: 'CISCO',
        image: require('@assets/images/partner/CISCO.png'),
        link: null
      },
      {
        title: '遠傳',
        image: require('@assets/images/partner/遠傳.png'),
        link: null
      },
      {
        title: '華電聯網',
        image: require('@assets/images/partner/華電聯網.png'),
        link: null
      },
      {
        title: 'PAPAGO',
        image: require('@assets/images/partner/PAPAGO.png'),
        link: null
      },
      {
        title: '物聯網智造基地',
        image: require('@assets/images/partner/物聯網智造基地.png'),
        link: null
      },
      {
        title: 'unabiz',
        image: require('@assets/images/partner/unabiz.png'),
        link: null
      },
      {
        title: 'auden',
        image: require('@assets/images/partner/auden.png'),
        link: null
      },
      {
        title: 'ＭEDNTEK',
        image: require('@assets/images/partner/ＭEDNTEK.png'),
        link: null
      },
      {
        title: 'awan',
        image: require('@assets/images/partner/awan.png'),
        link: null
      },
      {
        title: 'Inventec',
        image: require('@assets/images/partner/Inventec.png'),
        link: null
      },
      {
        title: 'flexium',
        image: require('@assets/images/partner/flexium.png'),
        link: null
      },
      {
        title: '川升股份有限公司',
        image: require('@assets/images/partner/川升股份有限公司.png'),
        link: null
      },
      {
        title: 'wnc',
        image: require('@assets/images/partner/wnc.png'),
      },
    ],
    "brands": [
      {
          "title": "AOD",
          "alias": "aod",
          "logo": require('@assets/images/about/microsoft@2.png'),
          "contact": [
            {
              "name": "林",
              "gender": "小姐",
              "countryCode": "02",
              "phone": "2656-5656",
              "extension": "919"
            }
          ]
      }
    ],
}